/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DatePickerModule } from './../calender/datepicker/date-picker.module';
import { PdfViewModule } from './../pdf-view/pdf-view.module';
import { PipesModule } from './../../pipes/pipes.module';
import { ShakaPlayerModule } from '../../shaka-player/shaka-player.module';
import { NgbDropDownModule } from './../ngb-drop-down/ngb-drop-down.module';
import { MediaModalModule } from '../../common/media-modal/media-modal.module';
import { ProductSubscribeModule } from './../product-subscribe/product-subscribe.module';
import { DirectivesModule } from './../../directives/directives.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { DropDownModule } from './../drop-down/drop-down.module';
import { CarouselModule } from 'angular-bootstrap-md';
import { ActionModalModule } from '../action-modal/action-modal.module';
import { ProductReportModule } from '../product-report/product-report.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MediaGalleryComponent } from '../media-gallery/media-gallery.component';
import { EventViewCertificateModule } from '../event-view-certificate/event-view-certificate.module';
import { SpeakerCardModule } from '../speaker-card/speaker-card.module';

/**
 * Component imports.
 */
import { ProductTncComponent } from '../product-tnc/product-tnc.component';
import { EventMedialListComponent } from './event-medial-list/event-medial-list.component';
import { EventSessionModalComponent } from './event-session-modal/event-session-modal.component';
import { EventSessionCertificateListComponent } from './event-session-certificate-list/event-session-certificate-list.component';
import { EventSpeakerListComponent } from './event-speaker-list/event-speaker-list.component';
import { DrugOrderFormComponent } from '../../drug-sample/drug-order-form/drug-order-form.component';
import { EventShareComponent } from '../event-share/event-share.component';
import { ProductShareComponent } from '../product-share/product-share.component';
import { WebModalComponent } from './web-modal.component';
import { CountryAndAssociationModalComponent } from '../verify-process/country-and-association-modal/country-and-association-modal.component';
import { AssociationVerificationModalComponent } from '../verify-process/association-verification-modal/association-verification-modal.component';
import { AssDocReqCardComponent } from '../verify-process/association-verification-modal/ass-doc-req-card/ass-doc-req-card.component';
import { VerificationSuccessModalComponent } from '../verify-process/verification-success-modal/verification-success-modal.component';
import { InfoComponent } from './info/info.component';
import { SuccessComponent } from './success/success.component';
import { CmeDescComponent } from './cme-desc/cme-desc.component';
import { UserNotVerifiedComponent } from './user-not-verified/user-not-verified.component';
import { WebCmeDetailModalComponent } from '../../web-cme/web-cme-detail-modal/web-cme-detail-modal.component';
import { FitInImgPipe } from '../../pipes/brokenimage.pipe';
import { ShareModule } from '../commons.module';


@NgModule({
  declarations: [
    WebModalComponent,
    CountryAndAssociationModalComponent,
    AssociationVerificationModalComponent,
    AssDocReqCardComponent,
    VerificationSuccessModalComponent,
    InfoComponent,
    SuccessComponent,
    CmeDescComponent,
    UserNotVerifiedComponent,
    WebCmeDetailModalComponent,
    ProductTncComponent,
    EventMedialListComponent,
    EventSessionModalComponent,
    EventSessionCertificateListComponent,
    EventSpeakerListComponent,
    DrugOrderFormComponent,
    EventShareComponent,
    ProductShareComponent,
    MediaGalleryComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DropDownModule,
    PerfectScrollbarModule,
    DirectivesModule,
    ProductSubscribeModule,
    MediaModalModule,
    CarouselModule,
    NgbDropDownModule,
    ShakaPlayerModule,
    ActionModalModule,
    ProductReportModule,
    ModalModule,
    EventViewCertificateModule,
    PipesModule,
    PdfViewModule,
    SpeakerCardModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    DatePickerModule,
    MatSelectModule,
    ShareModule
  ],
  exports: [
    WebModalComponent,
    WebCmeDetailModalComponent
  ],
  providers: [FitInImgPipe]
})
export class WebModalModule { }
